<div class="zwi-section">
  <zwi-headline>Account</zwi-headline>
  <div class="zwi-section">
    <zwi-body>To close you account and delete your data</zwi-body>
    <button mat-flat-button color="primary" (click)="openDialog()">Close account</button>
  </div>
</div>
<zwi-account-close-dialog [open]="open" (closed)="close()"></zwi-account-close-dialog>
